import { Field } from "./Field";
import { useCadForm } from "./formContext";
export interface TextFieldProps { id: string; label: string; value: string; onChange: (v: string) => void; required?: boolean; placeholder?: string; error?: string; type?: "text" | "date" }
export function TextField(p: TextFieldProps): JSX.Element {
  const cad = useCadForm();
  return (
    <Field label={p.label + (p.required ? " *" : "")} htmlFor={p.id} error={p.error}>
      <input id={p.id} type={p.type ?? "text"} className={cad ? "cad-prop-input font-sans" : "input font-sans"} value={p.value} placeholder={p.placeholder} aria-invalid={p.error ? "true" : undefined} aria-describedby={p.error ? `${p.id}-err` : undefined} onChange={(e) => p.onChange(e.target.value)} />
    </Field>
  );
}
